"use client";

import { Loader2 } from "lucide-react";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

function cookieValue(name: string): string | null {
  if (typeof document === "undefined") return null;
  const prefix = `${name}=`;
  const raw = document.cookie
    .split("; ")
    .find((item) => item.startsWith(prefix));
  if (!raw) return null;
  const value = raw.slice(prefix.length);
  return value || null;
}

export function hasClientSession(): boolean {
  const hasCookie = Boolean(
    cookieValue("auth-token") || cookieValue("refresh-token"),
  );
  if (!hasCookie) return false;
  try {
    return Boolean(localStorage.getItem("user"));
  } catch {
    return false;
  }
}

const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const locale = useLocale();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (hasClientSession()) {
      setAllowed(true);
      return;
    }
    setAllowed(false);
    router.replace(`/${locale}/login`);
  }, [locale, router]);

  if (!allowed) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return children;
};

export default RequireAuth;
